import { useState } from 'react';
import { IconButton, ListItemIcon, Menu, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  ArchiveRounded as ArchiveIcon,
  EditRounded as EditIcon,
  MoreVertRounded as MoreVertIcon,
  UnarchiveRounded as UnarchiveIcon,
} from '@material-ui/icons';

type Props = {
  rowId: string;
  isArchived: boolean;
  onEdit: () => void;
  onArchive: () => void;
  onRestore: () => void;
};

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '0.25rem',
  },
  menuIcon: {
    minWidth: 32,
  },
});

export function ArchivableRowActions({ rowId, isArchived, onEdit, onArchive, onRestore }: Props) {
  const classes = useStyles();
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);

  const menuId = `row-actions-${rowId}`;
  const isMenuOpen = Boolean(menuAnchor);

  const closeMenu = () => setMenuAnchor(null);

  const handleArchiveAction = () => {
    closeMenu();
    if (isArchived) {
      onRestore();
      return;
    }
    onArchive();
  };

  return (
    <div className={classes.root}>
      <IconButton size="small" aria-label="Modifier" disabled={isArchived} onClick={onEdit}>
        <EditIcon />
      </IconButton>
      <IconButton
        size="small"
        aria-label="Actions"
        aria-controls={isMenuOpen ? menuId : undefined}
        aria-haspopup="true"
        onClick={(event) => setMenuAnchor(event.currentTarget)}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu id={menuId} anchorEl={menuAnchor} open={isMenuOpen} onClose={closeMenu}>
        <MenuItem dense onClick={handleArchiveAction}>
          <ListItemIcon className={classes.menuIcon}>
            {isArchived ? <UnarchiveIcon fontSize="small" /> : <ArchiveIcon fontSize="small" />}
          </ListItemIcon>
          {isArchived ? 'Restaurer' : 'Archiver'}
        </MenuItem>
      </Menu>
    </div>
  );
}
